import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { IonicVue } from "@ionic/vue";
import "@ionic/vue/css/core.css";
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import "./theme/variables.css";
import "./theme/core.css";
import "animate.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "quill/dist/quill.snow.css";

// Impor Firebase
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAAknrNPp5m8tTzTW8znxHAITuLJUXxI70",
  authDomain: "gamasains-a23fd.firebaseapp.com",
  projectId: "gamasains-a23fd",
  storageBucket: "gamasains-a23fd.appspot.com",
  messagingSenderId: "904819787775",
  appId: "1:904819787775:web:9687cfd1fc922d02b849ca",
  measurementId: "G-2XTQKGHVVX",
};

// Inisialisasi Firebase
const firebaseApp = initializeApp(firebaseConfig);

const app = createApp(App)
  .component("swiper", Swiper)
  .component("swiper-slide", SwiperSlide)
  .use(IonicVue, {
    mode: "ios",
  })
  .use(router);

// Menetapkan firebaseApp ke objek app Vue
app.config.globalProperties.$firebase = firebaseApp;

router.isReady().then(() => {
  app.mount("#app");
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('Service Worker registered with scope:', registration.scope);
    }).catch(error => {
      console.log('Service Worker registration failed:', error);
    });
  });
}